var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-field',{attrs:{"label":_vm.schema.title,"message":_vm.schema.description}},[_c('b-input',{attrs:{"type":"number","min":_vm.schema.minimum,"max":_vm.schema.maximum,"step":_vm.schema.type === 'number' ? 'any' : '1',"value":_vm.value},on:{"input":function($event){_vm.$emit('input', Number($event))}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }